import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { EnvironmentType } from './environments/environment-type.enum';

if (environment.type === EnvironmentType.Prod ||
  environment.type === EnvironmentType.Sit ||
  environment.type === EnvironmentType.Qa) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
